// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"customerSettingsModal_modalBodyStyle__p2Et5","modal":"customerSettingsModal_modal__pAPpg","marginArea":"customerSettingsModal_marginArea__SPyBi"};